import { defineMessages } from '@sm/intl';

export const CORPOATE_SIGNATURE_RESEARCH_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpagePageCtaText',
    defaultMessage: 'Read the report',
    description: '[Type: header][Vis: high] - Invites users to read the research report',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpageHeading',
    defaultMessage: 'How to adapt in times of crisis',
    description: '[Type: header][Vis: high] - Attract user attention based on current world conditions',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpageSubheading',
    defaultMessage:
      'Learn the 2 traits that decide how well an organization will weather the pandemic. Read our exclusive research report, based on 3,000+ survey results.',
    description: '[Type: header][Vis: medium] - Summarizes and pique interest in the research report',
  },
});

export const CX_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.CxEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to GetFeedback homepage',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.CxEndpageHeading',
    defaultMessage: 'Get a CX platform that takes you straight to insights',
    description: '[Type: header][Vis: high] - Pique interest in GetFeedback',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.CxEndpageSubheading',
    defaultMessage: 'Sync customer feedback with data from your CRM using GetFeedback.',
    description: '[Type: header][Vis: medium] - Explain GetFeedback capabilities',
  },
});

export const FEATURED_EP_US_MAP_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.FeaturedEpUsMapCtaText',
    defaultMessage: 'Take the survey',
    description: '[Type: header][Vis: high] - Invites user to polling survey',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.FeaturedEpUsMapHeading',
    defaultMessage: 'Where do you stand on current events? Share your opinion.',
    description: '[Type: header][Vis: high] - Encourages user to share opinions on current events in their area',
  },
});

export const GO_BEYOND_TEXT_BANNER_COPY = defineMessages({
  CTA_TEXT: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerCtaText',
    defaultMessage: 'Visit Momentive',
    description: '[Type: header][Vis: high] - Invites users to Momentive homepage',
  },
  HEADING: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerHeading',
    defaultMessage: 'Go beyond collecting feedback',
    description: '[Type: header][Vis: high] - Pique interest in Momentive',
  },
  SUBHEADING: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerSubheading',
    defaultMessage:
      'Momentive, the maker of SurveyMonkey, offers solutions to help you drive change in your organization.',
    description: '[Type: header][Vis: medium] - Explain Momentive capabilities',
  },
});

export const MRX_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.MrxEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to blog post about Allbirds using SurveyMonkey',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.MrxEndpagePageHeading',
    defaultMessage: 'How Allbirds uses SurveyMonkey to track its explosive growth',
    description: '[Type: header][Vis: high] - Uses a popular brand to establish corporate trust.',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.MrxEndpageSubheading',
    defaultMessage: "Allbirds relies on SurveyMonkey market research to track its brand's expansion around the globe.",
    description: '[Type: header][Vis: medium] - Explains how Allbirds uses SurveyMonkey',
  },
});

export const POLLING_TEXT_BANNER_COPY = defineMessages({
  CTA_TEXT: {
    id: 'SurveyThanks.copy.PollingTextBannerCtaText',
    defaultMessage: 'See how',
    description: '[Type: header][Vis: high] - Invites users to SurveyMonkey homepage',
  },
  SUBHEADING: {
    id: 'SurveyThanks.copy.PollingTextBannerSubheading',
    defaultMessage:
      'More than 19 million users use SurveyMonkey to ask questions. Learn how you can use surveys to ask yours.',
    description: '[Type: header][Vis: medium] - Share the number of SurveyMonkey users to establish corporate trust',
  },
});

export const RACIAL_JUSTICE_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.RacialJusticeEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to marketing page about diversity',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.RacialJusticeEndpageHeading',
    defaultMessage: 'Get tools for addressing racial equity in the workplace',
    description: '[Type: header][Vis: high] - Appeal to interest in racial equity at work',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.RacialJusticeEndpageSubheading',
    defaultMessage:
      'Get survey templates, tools, and resources to start understanding the racial equity dynamics in your organization.',
    description: '[Type: header][Vis: medium] - Explain how SurveyMonkey can be used to address racial equity at work',
  },
});

export const STANDARD_ENDPAGE_DEFAULT_COPY = defineMessages({
  ENDPAGE_HEADER: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultEndpageHeader',
    defaultMessage: 'Thank you for taking this survey.',
    description: '[Type: header][Vis: medium] - Informs the viewer that this survey has just completed',
  },
  LOGO_ARIA_LABEL: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultHomepageLinkAriaLabel',
    defaultMessage: 'SurveyMonkey Home',
    description: '[Type: label][Vis: low] - Aria label for SurveyMonkeyLogoWithTest link to support accessibility',
  },
  PRIVACY_NOTICE: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultPrivacyNotice',
    defaultMessage: 'Privacy Notice',
    description: '[Type: link][Vis: low] - Text for link to SurveyMonkey Privacy Notice',
  },
});
